import * as React from 'react';
import { Helmet } from './meta';
import { getCanonicalBaseUrl, getLanguageId } from '../utils/globals';

const HomeSchema = () => {
  const url = `${getCanonicalBaseUrl()}/${getLanguageId()}`;
  return (
    <Helmet>
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url}></meta>
    </Helmet>
  );
};

export default HomeSchema;
